module.exports = __webpack_public_path__ + "img/candidate5.c08b0fef.png";